var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(_vm.image_src)?_c('img',{attrs:{"id":"image","src":_vm.image_src,"alt":"Imagen subida."}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }